import React from "react"
import { WithT } from "i18next"
import { AgentType } from "../../models/agent"
import TypeFormCard from "../TypeFormCard/TypeFormCard"
import AgentIcon from "../AgentIcon/AgentIcon"

const tNamespace = "agent:"

interface CardProps extends WithT {
    type: AgentType
    title: string
    onSelect: (type: AgentType) => void
    description?: string
    logo?: string
}

const AgentTypeFormCard: React.FC<CardProps> = props => {
    const { t, type, title, onSelect, description, logo } = props

    return (
        <TypeFormCard
            icon={<AgentIcon type={type} logo={logo} />}
            onSelect={() => onSelect(type)}
            title={title}
            description={description ?? t(`${tNamespace}agent-type-desc.${type}`)}
            testId={`${type}-agent-type`}
        />
    )
}

export default AgentTypeFormCard
